// Verzió: 1.2.0-06 2024-10-30
// Központosított, mapping-képes kliens. Aláírás változatlan.
import { API_REGISTRY } from './api/registry';

const trimRightSlash = (s) => s.replace(/\/+$/,'');
const defaultBase = () => (process.env.REACT_APP_API_BASE || 'https://hacsi.hu');

export const fetchDataFromServer = async (apiKey, variable, method = 'GET', value = '') => {
  const reg = API_REGISTRY[apiKey] || { baseUrl: '', map: {} };
  const base = trimRightSlash(reg.baseUrl || defaultBase());
  const map = reg.map || {};

  // appKulcs -> szerverKulcs (ha nincs mapping, változatlan)
  const srvVar = (variable ?? '') === '' ? '' : (map[variable] || variable);

  let url = `${base}/saveData.php`;

  // Paraméterek
  const params = new URLSearchParams();
  params.set('apikey', apiKey);
  if (srvVar !== '') params.set('var', srvVar);
  if (method === 'POST') params.set('value', String(value));

  // GET: querystring, POST: body
  const finalUrl = method === 'GET' ? `${url}?${params.toString()}` : url;

  try {
    const response = await fetch(finalUrl, {
      method,
      headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
      body: method === 'POST' ? params.toString() : undefined,
    });
    const raw = await response.json();

    // szerverKulcs -> appKulcs normalizálás
    const reverse = Object.fromEntries(Object.entries(map).map(([app, srv]) => [srv, app]));
    if (!reverse || Object.keys(reverse).length === 0) return raw;

    const normalized = {};
    for (const [k, v] of Object.entries(raw || {})) {
      const appKey = reverse[k] || k;
      normalized[appKey] = v;
    }
    return normalized;
  } catch (error) {
    console.error('Szerver hiba:', error);
    return { error: error.message };
  }
};
